import {
  Box,
  Chip,
  Divider as MuiDivider,
  Grid,
  IconButton,
  styled,
  Typography,
} from '@mui/material';
import { Button, Card } from '@sb/cc-design-system';

export const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  min-width: 0;
`;

export const PageCard = styled(Card)`
  width: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

export const Content = styled(Grid)`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  width: 100%;
  box-sizing: border-box;
  padding: 12px 12px 6px;
  margin: 0 !important;
  gap: 24px;
`;

export const SidePanelWrapper = styled(Grid)`
  --side-panel-control-width: min(248px, calc(100vw - 88px));
  margin-top: 0;
  display: flex;
  flex: 0 0 auto;

  @media (min-width: 900px) {
    width: calc(var(--side-panel-control-width) + 80px);
    max-width: none;
  }

  @media (max-width: 899.95px) {
    width: 100%;
  }
`;

export const SIDE_PANEL_CARD_DESIGN = {
  borderRadius: 24,
  backgroundColor: '#FFFFFF',
  boxShadow: 'none',
  paddingTop: 0,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0,
};

export const SIDE_PANEL_CARD_BODY_STYLES = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
} as const;

export const SidePanelCard = styled(Card)`
  border: 1px solid #d7d7d9;
  border-radius: 24px;
  height: calc(100vh - 190px);
  overflow: hidden;
  display: inline-flex;
  flex-direction: column;
  flex: 0 0 auto;
  align-self: flex-start;
  width: min(100%, calc(var(--side-panel-control-width) + 80px));
  max-width: 100%;
`;

export const InCardNavbar = styled(Box)`
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

export const InCardNavbarLeft = styled(Box)`
  display: flex;
  align-items: center;
  min-width: 0;
  gap: 6px;
`;

export const InCardNavbarActions = styled(Box)`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const InCardHomeButton = styled(IconButton)`
  width: 24px;
  height: 24px;
  color: var(--Text-onLight-secondary, #181c2099);
  font-size: 14px;
`;

export const InCardBreadcrumbs = styled(Box)`
  min-width: 0;

  .MuiBreadcrumbs-ol {
    flex-wrap: nowrap;
  }

  .MuiTypography-root,
  .MuiLink-root {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    vertical-align: middle;
  }

  .MuiBreadcrumbs-separator {
    margin: 0 8px;
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    vertical-align: middle;
  }

  .MuiBreadcrumbs-li:last-child .MuiTypography-root {
    color: #181c20;
  }
`;

export const InCardPublishButton = styled(Button)`
  border-radius: 999px;
  box-shadow: none;

  &:hover {
    box-shadow: none;
  }
`;

export const InCardSaveButton = styled(Button)`
  border-radius: 999px;
`;

export const SidePanelScroll = styled(Box)`
  padding: 12px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  &::-webkit-scrollbar {
    width: 0;
  }
`;

export const LocationName = styled(Typography)`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 28px;
  letter-spacing: 0;
  margin-bottom: 10px;
`;

export const Section = styled(Grid)`
  padding: 0;
`;

export const StoreLocation = styled(Grid)`
  padding-top: 10px !important;
`;

export const Divider = styled(MuiDivider)(
  ({ theme, $marginTop = 8, $marginBottom = 10 }) => `
    border-color: ${theme.palette.grey[200]};
    margin-top: ${$marginTop}px;
    margin-bottom: ${$marginBottom}px;
  `,
);

export const SubHeader = styled(Typography)`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: 0;
  color: #000000;
`;

export const SubHeaderText = styled(Typography)`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 450;
  font-size: 14px;
  line-height: 16px;
  letter-spacing: 0;
  color: #000000;
  margin-top: 2px;
`;

export const OOTagsContainer = styled(Box)`
  margin-top: 10px;
`;

export const OOTagDropdownWrapper = styled(Box)`
  width: 100%;
  min-width: 0;

  .MuiFormControl-root,
  .MuiInputBase-root,
  .MuiSelect-select {
    min-width: 0;
  }

  .MuiFormControl-root + .MuiStack-root {
    display: none;
  }
`;

export const OOTagList = styled(Box)`
  width: 100%;
  min-width: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 8px;
`;

export const OOTagChip = styled(Chip)`
  max-width: 100%;
  background-color: #eef1f5;
  color: #6b7280;

  .MuiChip-deleteIcon {
    color: #9aa3af;
  }
`;

export const OOTagLabel = styled('span')`
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const OOToggleRow = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-top: 8px;
  box-sizing: border-box;
`;

export const OOToggleLabel = styled(Typography)`
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  color: #000000;
  margin: 0;
  flex: 1;
  min-width: 0;
`;

export const LocationTagSelect = styled(Box)`
  margin-top: 8px;
  height: 30px;
  border-radius: 16px;
  border: 1px solid #d1d5db;
  background: #f3f4f6;
  color: #6b7280;
  font-size: 12px;
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &::after {
    content: '⌄';
    font-size: 12px;
    color: #6b7280;
  }
`;

export const ChipSpacer = styled(Box)`
  margin: 0 5px 5px 0;
  display: inline-block;
`;

export const ChannelGridContainer = styled(Grid)`
  margin-top: 0;
  flex: 1 1 0;
  min-width: 0;
  max-width: none;

  @media (max-width: 899.95px) {
    width: 100%;
    max-width: 100%;
  }
`;

export const ChannelsGrid = styled(Grid)`
  margin: 0;
  width: 100%;
`;

export const ChannelTileGridItem = styled(Grid)`
  margin-bottom: 16px;
`;

export const LocationTagDropdownInputSx = {
  width: '100%',
  maxWidth: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: '24px',
    minHeight: '26px',
    backgroundColor: '#fff',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '24px',
  },
  '& .MuiSelect-select': {
    color: '#6b7280',
    display: 'flex',
    alignItems: 'center',
    minHeight: '10px',
    boxSizing: 'border-box',
  },
};

export const LOCATION_TAG_DROPDOWN_SELECT_PADDING = '10px 36px 10px 16px';

export const LOCATION_TAG_BADGE_SX = {
  backgroundColor: '#eef1f5',
  color: '#6b7280',
  maxWidth: '100%',
  '& .MuiChip-label': {
    color: '#6b7280',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '220px',
  },
  '& .MuiChip-deleteIcon': {
    color: '#9aa3af',
  },
};

export const ChannelPreview = styled(Box)`
  height: 138px;
  background: #f3f4f8;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChannelFooter = styled(Box)`
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  min-height: 62px;
`;

export const ChannelName = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  color: #191b23;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
`;

export const ChannelMeta = styled(Typography)`
  font-size: 12px;
  color: #6b7280;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
`;

export const ChannelGroupLink = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  marginTop: 3,
  color: theme.palette.primary.main,
  cursor: 'pointer',
  textDecoration: 'none',
}));

export const ChannelActions = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;

  .MuiIconButton-root {
    color: #6b7280;
    font-size: 20px;
  }
`;
